import React from 'react';

const RoundBTN = (props) => {
    return (
        <button 
            className="roundBTN" onClick={() => props.click(props.clickVal)} disabled={props.disabled}>
                <i className="icon"> {props.icon} </i>
        </button>
    );
}

export default RoundBTN;